import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

export const sendInvitation = createAsyncThunk(
    'invitation/send',
    async (email, { dispatch }) => {
        try {
            const response = await axios.post('/api/invitation/send', { email }, getAuthHeader());
            dispatch(successGlobal('Pozvánka bola úspešne odoslaná.'));
            return response.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri odosielaní pozvánky.'));
            throw error;
        }
    }
);

export const fetchMyInvitations = createAsyncThunk(
    'invitation/fetchMy',
    async (_, { dispatch }) => {
        try {
            const response = await axios.get('/api/invitation/my', getAuthHeader());
            return response.data;
        } catch (error) {
            dispatch(errorGlobal('Nepodarilo sa načítať pozvánky.'));
            throw error;
        }
    }
);

export const fetchSentInvitations = createAsyncThunk(
    'invitation/fetchSent',
    async (_, { dispatch }) => {
        try {
            const response = await axios.get('/api/invitation/sent', getAuthHeader());
            return response.data;
        } catch (error) {
            dispatch(errorGlobal('Nepodarilo sa načítať odoslané pozvánky.'));
            throw error;
        }
    }
);

export const acceptInvitation = createAsyncThunk(
    'invitation/accept',
    async (id, { dispatch }) => {
        try {
            const response = await axios.post(`/api/invitation/${id}/accept`, {}, getAuthHeader());
            dispatch(successGlobal('Pozvánka bola prijatá.'));
            return id;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri prijímaní pozvánky.'));
            throw error;
        }
    }
);

export const cancelInvitation = createAsyncThunk(
    'invitation/cancel',
    async (id, { dispatch }) => {
        try {
            await axios.delete(`/api/invitation/${id}`, getAuthHeader());
            dispatch(successGlobal('Pozvánka bola zrušená.'));
            return id;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri rušení pozvánky.'));
            throw error;
        }
    }
);

export const declineInvitation = createAsyncThunk(
    'invitation/decline',
    async (id, { dispatch }) => {
        try {
            await axios.post(`/api/invitation/${id}/decline`, {}, getAuthHeader());
            dispatch(successGlobal('Pozvánka bola odmietnutá.'));
            return id;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri odmietaní pozvánky.'));
            throw error;
        }
    }
);
